module.exports = {"message":"hello i18n !!"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/pt.json
// module id = 358
// module chunks = 43